import { type ReactElement } from 'react'

import { LoadingRegion } from '@orus.eu/pharaoh-next/components/ui/loading-region'
import { Skeleton } from '@orus.eu/pharaoh-next/components/ui/skeleton'
import { View } from '@orus.eu/pharaoh-next/components/ui/view'

/** Pending placeholder for the Report claim screen — shares the View frame with the real content. */
export function ReportClaimPageSkeleton(): ReactElement {
  return (
    <LoadingRegion label="Chargement">
      <View.Root>
        <View.Header>
          <Skeleton variant="text" width={220} height={32} />
        </View.Header>
        <View.Body>
          <Skeleton variant="text" width={160} height={24} />
          <div
            className="
              grid gap-stack
              md:grid-cols-2
            "
          >
            <Skeleton variant="block" height={280} />
            <Skeleton variant="block" height={280} />
          </div>
        </View.Body>
      </View.Root>
    </LoadingRegion>
  )
}
